/* eslint-disable import/prefer-default-export */
export const buildMatchExpression = ({
  data,
  geoJoinKey,
  dataJoinKey,
  dataAccessor,
  colorScale,
}) => {
  /**
   * Helper func that creates a mapbox 'match expression', which can be passed to the style property in mapbox layers
   * in order to add choropleth styles.
   *
   * @param {arr<obj>} data: array of objects to use for match expression
   * @param {string} geoJoinKey: The key on each geographic feature that will act as a join key.
   * @param {string} dataJoinKey: The key on each object that will act as a join key.
   * @param {string} dataAccessor: The key that will be used for the choropleth colors.
   * @param {func} colorScale: a function that will determine the color based on each value from dataAccessor
   * @returns {arr} match expression
   */

  // Build a GL match expression that defines the color for every vector tile feature
  const matchExpression = ["match", ["get", geoJoinKey]];
  // Calculate color values for each country based on 'hdi' value
  data.forEach((row) => {
    // Convert the range of data values to a suitable color
    const color = colorScale(row[dataAccessor]);
    // const color = row[dataAccessor]
    //   ? colorScale(row[dataAccessor])
    //   : noDataColor;

    matchExpression.push(row[dataJoinKey], color);
  });
  // Last value is the default, used where there is no data
  matchExpression.push("rgba(0, 0, 0, 0)");
  return matchExpression;
};
